<!-- <div class="h-[100dvh] justify-between flex flex-col">
  <div class="">
    <div class="mb-2">
      <p-button
        severity="secondary"
        type="button"
        icon="pi pi-user-plus"
        label="Agregar Paciente"
        (onClick)="toggle($event)"
      />
      <p-popover #op>
        <div class="flex flex-col gap-4">
          <div>
            <span class="font-medium block mb-2">Team Members</span>
            <ul class="list-none p-0 m-0 flex flex-col">
              <li><a routerLink="crear-tbs">Some</a></li>
            </ul>
          </div>
        </div>
      </p-popover>
    </div>
    <div class="pb-2">
      <app-grid />
    </div>
  </div>
</div> -->
<div class="h-[calc(100dvh-4rem)] md:pl-16 mt-4">
  <router-outlet />
</div>
<app-nav-bar />
